import { render, staticRenderFns } from "./ClinicAppliesListing.vue?vue&type=template&id=0b9b5f54"
import script from "./ClinicAppliesListing.vue?vue&type=script&lang=js"
export * from "./ClinicAppliesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports